if (!customElements.get('box-builder')) {
  class BoxBuilder extends HTMLElement {
    constructor() {
      super();

      this.initializeProperties();
      this.cacheElements();
    }

    initializeProperties() {
      this.activeTab = '';
      this.activePreview = '';
      this.currentBox = '';
      this.currentSubmitForm = '';
      this.progress = '';
      this.boxLimit = '';
      this.boxSubmit = '';
      this.boxIsDisabled = false;
      this.boxCounter = 0;
    }

    cacheElements() {
      this.boxPlaceholder = this.querySelector('[data-placeholder]').innerHTML;
      this.filterNavigations = this.querySelectorAll('[data-box-filters]');
      this.filterButtons = this.querySelectorAll('[data-box-filters] button');
      this.resetButtons = this.querySelectorAll('[data-reset]');
      this.step1 = this.querySelector('[data-step="1"]');
      this.step2 = this.querySelector('[data-step="2"]');
      this.filterToggle = this.querySelectorAll('[data-facets-toggle]');
      this.boxTriggers = this.querySelectorAll('[data-tab-trigger]');
      this.boxAddForms = this.querySelectorAll('[data-box-add-form]');
      this.filteredItems = this.querySelectorAll('[data-filter-items] li');
    }

    connectedCallback() {
      this.addEventListeners();
      this.initFilterNav();
    }

    addEventListeners() {
      this.boxTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleTabClick(trigger);
        });
      });

      this.resetButtons.forEach((resetButton) => {
        resetButton.addEventListener('click', () => this.resetBox());
      });

      this.boxAddForms.forEach((boxAddForm) => {
        boxAddForm.addEventListener('submit', (event) => {
          event.preventDefault();
          this.handleFormSubmit(boxAddForm);
        });
      });

      this.filterToggle.forEach((summaryButton) => {
        summaryButton.addEventListener('click', () =>
          this.toggleFilter(summaryButton),
        );
      });

      document.addEventListener('click', (event) => {
        const removeButton = event.target.closest('[data-box-remove]');

        if (removeButton) {
          this.removeItem(removeButton);
        }
      });
    }

    handleTabClick(trigger) {
      this.initNextStep();
      this.initActiveTab(trigger);
    }

    handleFormSubmit(boxAddForm) {
      if (!this.boxIsDisabled) {
        this.updateMainProductForm(boxAddForm);
        this.updateBoxImages(boxAddForm);
        this.updateButtonText(boxAddForm);
        this.updateButtonCounter();
        this.updateAddToCartButton();
      }
    }

    toggleFilter(summaryButton) {
      const details = summaryButton.closest('details');
      const summaryButtonText = summaryButton.querySelector('span');
      summaryButtonText.textContent = details.open
        ? summaryButton.dataset.showText
        : summaryButton.dataset.hideText;
    }

    initFilterNav() {
      this.filterNavigations.forEach((filterNav) => {
        const filterButtons = filterNav.querySelectorAll('button');
        filterButtons.forEach((button) => {
          button.addEventListener('click', (event) =>
            this.handleButtonClick(event, filterButtons),
          );
        });
      });
    }

    handleButtonClick(event, buttons) {
      const filter = event.target.dataset.filter;
      const listItems = event.target
        .closest('.js-main-tab')
        .querySelectorAll('[data-filter-items] li');

      if (filter === 'tag-all') {
        buttons.forEach((button) => button.classList.remove('active'));
        event.target.classList.add('active');
        this.filterItems([filter], listItems);
      } else {
        event.target.classList.toggle('active');

        const allButton = Array.from(buttons).find(
          (button) => button.dataset.filter === 'tag-all',
        );
        if (allButton) {
          allButton.classList.remove('active');
        }

        const activeFilters = Array.from(buttons)
          .filter((button) => button.classList.contains('active'))
          .map((button) => button.dataset.filter);

        this.filterItems(activeFilters, listItems);
      }
    }

    filterItems(activeFilters, items) {
      if (activeFilters.includes('tag-all') || activeFilters.length === 0) {
        items.forEach((item) => item.classList.add('active'));
      } else {
        items.forEach((item) => {
          const matches = activeFilters.some((filter) =>
            item.dataset.tags.includes(filter),
          );
          item.classList.toggle('active', matches);
        });
      }
    }

    initNextStep() {
      this.step2.classList.add('visible');
      this.step1.classList.remove('visible');
    }

    initActiveTab(tabTrigger) {
      const currentTab = this.querySelector(
        `[data-tab="${tabTrigger.dataset.tabTrigger}"]`,
      );
      this.updateActiveTabSiblings(tabTrigger);
      currentTab.classList.add('active');

      if (currentTab.classList.contains('js-main-tab')) {
        this.setActiveTabElements(currentTab, tabTrigger);
      }
    }

    updateActiveTabSiblings(tabTrigger) {
      if (tabTrigger.dataset.siblings) {
        const siblings = this.querySelectorAll(
          `[data-group="${tabTrigger.dataset.siblings}"]`,
        );
        siblings.forEach((sibling) => sibling.classList.remove('active'));
      }
    }

    setActiveTabElements(currentTab, tabTrigger) {
      this.activeTab = currentTab;
      this.currentBox = this.activeTab.querySelector('[data-box-collection]');
      this.currentSubmitForm = this.activeTab.querySelector('quickbuy-form');
      this.progress = this.activeTab.querySelector('[data-progress]');
      this.boxLimit = Number(tabTrigger.dataset.boxSize);
      this.boxSubmit = this.activeTab.querySelector('[data-box-submit]');
      this.boxSubmit.disabled = true;
      this.progress.innerHTML = 0;
    }

    updateMainProductForm(form) {
      const lineItemInput = form.querySelector('[data-line-input] input');
      const clonedInput = lineItemInput.cloneNode(true);

      if (this.currentSubmitForm) {
        const lineItemsContainer =
          this.currentSubmitForm.querySelector('[data-line-items]');
        this.addOrUpdateLineItem(clonedInput, lineItemsContainer);
      }
    }

    addOrUpdateLineItem(clonedInput, lineItemsContainer) {
      const existingInputs = lineItemsContainer.querySelectorAll(
        'input[type="hidden"]',
      );
      let inputExists = false;

      existingInputs.forEach((input) => {
        if (input.value === clonedInput.value) {
          inputExists = true;
          this.updateLineItemQuantity(input);
        }
      });

      if (!inputExists) {
        lineItemsContainer.appendChild(clonedInput);
      }
    }

    updateLineItemQuantity(input) {
      let quantity = 0;
      let name = input.name;

      if (input.name.includes(' (')) {
        quantity = Number(name.split(')')[0].split('(')[1]) + 1;
        name = `${name.split(' (')[0]} (${quantity})]`;
      } else {
        quantity = 2;
        name = input.name.replace(']', ` (${quantity})]`);
      }

      input.name = `${name}`;
    }

    updateBoxImages(form) {
      const currentImage = form.querySelector('[data-image]').innerHTML;
      const boxItem = this.currentBox.querySelector('li:not(.filled)');

      if (boxItem) {
        boxItem.innerHTML = currentImage;
        boxItem.classList.add('filled');
      }
    }

    updateButtonCounter() {
      this.boxCounter++;
      this.progress.innerHTML = this.boxCounter;
    }

    decreaseButtonCounter() {
      this.boxCounter--;
      this.progress.innerHTML = this.boxCounter;

      this.boxSubmit.disabled = true;
      this.boxIsDisabled = false;
      this.toggleSubmitButtonText();
    }

    updateAddToCartButton() {
      if (this.boxCounter === this.boxLimit) {
        this.boxSubmit.disabled = false;
        this.boxIsDisabled = true;
        this.toggleSubmitButtonText();
      }
    }

    updateButtonText(form) {
      const formSubmitButton = form.querySelector('button[type="submit"]');
      const buttonTextDefault = formSubmitButton.querySelector(
        '[data-text-default]',
      );
      const buttonTextAdded =
        formSubmitButton.querySelector('[data-text-added]');

      buttonTextDefault.classList.add('hidden');
      buttonTextAdded.classList.remove('hidden');

      setTimeout(() => {
        buttonTextDefault.classList.remove('hidden');
        buttonTextAdded.classList.add('hidden');
      }, 1000);
    }

    toggleSubmitButtonText() {
      const successText = this.boxSubmit.querySelector('.js-text-success');
      const progressText = this.boxSubmit.querySelector('.js-text-progress');

      const isDisabled = this.boxIsDisabled;

      successText.classList.toggle('hidden', !isDisabled);
      progressText.classList.toggle('hidden', isDisabled);
    }

    resetBox() {
      this.initializeProperties();
      this.resetTabs();
      this.resetAddToCart();
      this.resetBoxCollection();
      this.resetAddToCartForm();
      this.resetErrors();
      this.resetFilters();
    }

    resetTabs() {
      this.step2.classList.remove('visible');
      this.step1.classList.add('visible');

      this.querySelectorAll('.js-main-tab').forEach((mainTab) =>
        mainTab.classList.remove('active'),
      );
    }

    resetBoxCollection() {
      this.querySelectorAll('[data-box-collection] li').forEach((item) => {
        item.classList.remove('filled');
        item.innerHTML = this.boxPlaceholder;
      });
    }

    removeItem(button) {
      const currentItem = button.closest('li');
      const newListItem = document.createElement('li');
      newListItem.innerHTML = this.boxPlaceholder;

      const currentLineItems = this.currentSubmitForm
        .querySelector('[data-line-items]')
        .querySelectorAll('input');
      const variantId = Number(button.dataset.id);

      currentLineItems.forEach((lineInput) => {
        if (variantId === Number(lineInput.value)) {
          if (lineInput.name.includes(')]')) {
            const quantity =
              Number(lineInput.name.split('(')[1].split(')')[0]) - 1;
            const newString = this.replaceBracketValue(
              lineInput.name,
              quantity,
            );

            lineInput.name = newString;
          } else {
            lineInput.remove();
          }

          currentItem.remove();
          this.currentBox.appendChild(newListItem);
          this.decreaseButtonCounter();
        }
      });
    }

    replaceBracketValue(inputString, newValue) {
      if (newValue === 1) {
        return inputString
          .replace(/\[(.*\(\d+\))\]/, function (match, p1) {
            return `[${p1.replace(/\s*\(\d+\)/, '')}]`;
          })
          .replace(/\[\s*\]/, '');
      } else {
        return inputString.replace(/\[(.*\(\d+\))\]/, function (match, p1) {
          return `[${p1.replace(/\(\d+\)/, `(${newValue})`)}]`;
        });
      }
    }

    resetAddToCart() {
      this.querySelectorAll('[data-box-submit]').forEach((button) => {
        button.querySelector('.js-text-success').classList.add('hidden');
        button.querySelector('.js-text-progress').classList.remove('hidden');
      });
    }

    resetAddToCartForm() {
      this.querySelectorAll('[data-line-items]').forEach(
        (lineItemsContainer) => {
          lineItemsContainer.innerHTML = '';
        },
      );
    }

    resetErrors() {
      this.querySelectorAll('[data-error-wrapper]').forEach((error) => {
        error.innerHTML = '';
      });
    }

    resetFilters() {
      this.filteredItems.forEach((item) => {
        item.classList.add('active');
      });

      this.filterButtons.forEach((filterButton) => {
        filterButton.classList.remove('active');
      });
    }
  }

  customElements.define('box-builder', BoxBuilder);
}
